// Public Mapbox tokens + basemap style, shared by the interactive map (MapComponent) and the
// static-image preview (hotel-detail/common/staticMap). Single source of truth so rotating a
// token or the style id updates both surfaces at once.
export const MAPBOX_ACCESS_TOKEN =
  'pk.eyJ1IjoibGFzdG1pbnV0ZSIsImEiOiJjanNieHZ2M2IwZmsxNDRzMjFyaGhoZGphIn0.OyyFa67nXT8ItjRMbAz4Jg';
export const MAPBOX_ACCESS_TOKEN_WHITELABEL =
  'pk.eyJ1IjoibGFzdG1pbnV0ZSIsImEiOiJjbGZqeWZnOWEwNWpuNDZzNGlqeDdyNnFnIn0.GnqeibYYl3_83qizC_CSRw';

// `{username}/{styleId}` of the shared lastminute basemap style.
export const MAPBOX_STYLE_ID = 'lastminute/cmfxr3vvu00as01sc66zh5be9';

export const enum MAP_STYLE_TYPE {
  DEFAULT = 'DEFAULT',
  SATELLITE = 'SATELLITE',
}

export const MAP_STYLES = {
  [MAP_STYLE_TYPE.DEFAULT]: {
    type: `mapbox://styles/${MAPBOX_STYLE_ID}`,
    icon: 'map-default.png',
  },
  [MAP_STYLE_TYPE.SATELLITE]: {
    type: 'mapbox://styles/mapbox/satellite-v9',
    icon: 'map-satellite.jpg',
  },
};
